<button class="iso-round-button" (click)="addCloseDate()">{{ 'bikeshop.users.new_closed_date' | translate}}</button>

<br/>
<br/>
<br/>
<div class="content">
  <table class="closing-date-table">
    <thead>
    <tr>
      <th>{{ 'bikeshop.users.description' | translate}}</th>
      <th>{{ 'bikeshop.users.start' | translate}}</th>
      <th>{{ 'bikeshop.users.end' | translate}}</th>
      <th>{{ 'bikeshop.users.days' | translate}}</th>
      <th>{{ 'bikeshop.users.actions' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let event of closedDates; let i = index">
      <td>{{ event.Description }}</td>
      <td>{{ (event.StartTime.toISOString ? event.StartTime.toISOString() : event.StartTime).split("T")[0] | date :
        countryData.AngularDateFormat }}</td>
      <td>{{ (event.EndTime.toISOString ? event.EndTime.toISOString() : event.EndTime).split("T")[0] | date :
        countryData.AngularDateFormat }}</td>
      <td>
        {{ days[i] + 1 }}
      </td>
      <td>
        <div style="display: flex;">
          <div pTooltip="{{'bikeshop.modal.add_edit_user.technician_form.edit_this_event' | translate}}"
               tooltipPosition="left" tooltipZIndex="10000" class="hubtiger-edit font-button"
               (click)="editEvent.toggle($event)">
          </div>
          <div pTooltip="{{'bikeshop.modal.add_edit_user.technician_form.delete_this_event' | translate}}"
               tooltipPosition="left" tooltipZIndex="10000" class="hubtiger-delete font-button"
               (click)="deleteEvent(event, i)">
          </div>
          <div style="position: absolute;right: 454px;top: 175px;">
            <p-overlayPanel #editEvent [dismissable]="false" [showCloseIcon]="true">
              <!--               todo (dcorbett) no user   [user]="user"-->
              <app-edit-event [leaveEvent]="leaveEvent" [event]="event" [index]="i"
                              [technicianEvents]="technicianEvents" [eventPopup]="editEvent"></app-edit-event>
            </p-overlayPanel>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</div>
